import { Link, NavLink } from "react-router-dom";
import { Menu, Search, ShoppingBag, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useStore } from "@/context/StoreContext";

const LINKS = [
  { to: "/shop?new=1", label: "New In" },
  { to: "/shop", label: "Shop all" },
  { to: "/shop?category=Kurtis", label: "Kurtis" },
  { to: "/shop?category=Anarkali", label: "Anarkali" },
  { to: "/shop?category=Dresses", label: "Dresses" },
  { to: "/shop?category=Festive%20Wear", label: "Festive" },
];

export default function Header() {
  const { count } = useStore();
  const [open, setOpen] = useState(false);
  useEffect(() => { document.body.style.overflow = open ? "hidden" : ""; return () => { document.body.style.overflow = ""; }; }, [open]);
  return (
    <>
      <div className="announcement" data-testid="announcement">Complimentary shipping over ₹2,500 · Call +91 9769128394 · Cash on delivery available</div>
      <header className="lux-header" data-testid="site-header">
        <button className="icon-button mobile-only" onClick={() => setOpen(true)} data-testid="mobile-menu-button" aria-label="Menu"><Menu size={20} /></button>
        <Link className="lux-brand" to="/" data-testid="brand-link" onClick={() => setOpen(false)}><img className="brand-logo" src="/logo-256.png" alt="Arisha Creations logo" data-testid="header-logo" /><span className="brand-text"><span>ARISHA</span><small>CREATIONS</small></span></Link>
        <nav className="lux-nav" data-testid="main-navigation">
          {LINKS.map(l => <NavLink key={l.to} to={l.to}>{l.label}</NavLink>)}
        </nav>
        <div className="lux-header-actions">
          <Link to="/shop" className="icon-button" data-testid="search-button" aria-label="Search"><Search size={19} /></Link>
          <Link to="/cart" className="icon-button" data-testid="cart-toggle-button" aria-label="Cart">
            <ShoppingBag size={20} />{count > 0 && <b data-testid="cart-count">{count}</b>}
          </Link>
        </div>
      </header>

      {open && (
        <div className="mobile-sheet" data-testid="mobile-sheet">
          <div className="mobile-sheet-head">
            <span className="lux-brand"><span>ARISHA</span><small>CREATIONS</small></span>
            <button className="icon-button" onClick={() => setOpen(false)} data-testid="mobile-close" aria-label="Close"><X size={22} /></button>
          </div>
          <nav>
            {LINKS.map(l => <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)}>{l.label}</NavLink>)}
            <NavLink to="/cart" onClick={() => setOpen(false)}>Bag ({count})</NavLink>
          </nav>
          <div className="mobile-sheet-foot">
            <a href="tel:+919769128394">+91 9769128394</a>
            <a href="https://wa.me/919769128394" target="_blank" rel="noreferrer">WhatsApp</a>
          </div>
        </div>
      )}
    </>
  );
}
